<div class="modal fade show d-block" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">

      <!-- Header -->
      <div class="modal-header User-Form">
        <h5 class="modal-title text-primary">User Form</h5>
        <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
      </div>

      <!-- Body -->
      <div class="modal-body">
        <form class="d-flex flex-column gap-1">

          <!-- Username -->
          <app-input 
            [customClass]="'text-black'"
            [inputName]="'username'"
            [inputType]="'text'"
            [inputId]="'usernameId'"
            [inputValue]="userForm.username"
            [inputLabel]="'User Name'"
            [inputPlaceholder]="'Enter username'"
            (inputValueEmit)="userForm.username = $event"
            [isRequired]="true">
          </app-input>

          <!-- Password -->
          <app-input 
            [customClass]="'text-black'"
            [inputName]="'password'"
            [inputType]="'password'"
            [inputId]="'passwordId'"
            [inputValue]="userForm.password"
            [inputLabel]="'Password'"
            [inputPlaceholder]="'Enter password'"
            (inputValueEmit)="userForm.password = $event"
            [isRequired]="true">
          </app-input>

          <app-input *ngIf="isSalonStepsBranch"
            [customClass]="'text-black'"
            [inputName]="'email'"
            [inputType]="'email'"
            [inputId]="'email'"
            [inputValue]="userForm.email"
            [inputLabel]="'Email'"
            [inputPlaceholder]="'Enter email'"
            (inputValueEmit)="userForm.email = $event"
            [isRequired]="true">
          </app-input>

          <!-- GST No -->
          <app-input *ngIf="!isSwarnAppBranch && !isSalonStepsBranch"
            [customClass]="'text-black'"
            [inputName]="'ipAddress'"
            [inputType]="'text'"
            [inputId]="'ipAddress'"
            [inputValue]="userForm.ipAddress"
            [inputLabel]="'Ip Address'"
            [inputPlaceholder]="'Enter Ip Address'"
            (inputValueEmit)="userForm.ipAddress = $event"
            [isRequired]="true">
          </app-input>

          <app-input *ngIf="isSwarnAppBranch && !isSalonStepsBranch"
            [customClass]="'text-black'"
            [inputName]="'gstTrn'"
            [inputType]="'text'"
            [inputId]="'gstTrn'"
            [inputValue]="userForm.gstTrn"
            [inputLabel]="'GST/TRN'"
            [inputPlaceholder]="'Enter GST/TRN'"
            (inputValueEmit)="userForm.gstTrn = $event"
            [isRequired]="true">
          </app-input>

          <app-input 
            [customClass]="'text-black'"
            [inputName]="'accessToken'"
            [inputType]="'text'"
            [inputId]="'accessToken'"
            [inputValue]="userForm.accessToken"
            [inputLabel]="'Access Token'"
            [inputPlaceholder]="'Enter Access Token'"
            (inputValueEmit)="userForm.accessToken = $event">
          </app-input>

          <app-input 
            [customClass]="'text-black'"
            [inputName]="'phoneNumber'"
            [inputType]="'text'"
            [inputId]="'phoneNumber'"
            [inputValue]="userForm.phoneNumber"
            [inputLabel]="'Phone Number'"
            [inputPlaceholder]="'Enter Phone Number'"
            (inputValueEmit)="userForm.phoneNumber = $event">
          </app-input>

          <app-input 
            [customClass]="'text-black'"
            [inputName]="'wabaId'"
            [inputType]="'text'"
            [inputId]="'wabaId'"
            [inputValue]="userForm.wabaId"
            [inputLabel]="'Waba Id'"
            [inputPlaceholder]="'Enter Waba Id'"
            (inputValueEmit)="userForm.wabaId = $event">
          </app-input>

          <app-input 
            [customClass]="'text-black'"
            [inputName]="'businessId'"
            [inputType]="'text'"
            [inputId]="'businessId'"
            [inputValue]="userForm.businessId"
            [inputLabel]="'Business Id'"
            [inputPlaceholder]="'Enter Business Id'"
            (inputValueEmit)="userForm.businessId = $event">
          </app-input>

        </form>
      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <app-button 
        class="btns"
          [customClass]="'danger'"
          [buttonLabel]="'Close'"
          (click)="activeModal.dismiss()">
        </app-button>

        <app-button
        class="btns"
          [customClass]="'primary'"
          [buttonLabel]="'Save'"
          (click)="save()">
        </app-button>
      </div>

    </div>
  </div>
</div>